'use strict';

exports.__esModule = true;
var INFO = exports.INFO = 'info';
var ADVERTENCIA = exports.ADVERTENCIA = 'warn';
var ERROR = exports.ERROR = 'error';
var EXITO = exports.EXITO = 'success';